var map = {
	"./AppleAppStoreIcon": 64329,
	"./AppleAppStoreIcon.tsx": 64329,
	"./ArrowDownFilledIcon": 30562,
	"./ArrowDownFilledIcon.tsx": 30562,
	"./ArrowDownIcon": 15926,
	"./ArrowDownIcon.tsx": 15926,
	"./ArrowLeftIcon": 42049,
	"./ArrowLeftIcon.tsx": 42049,
	"./ArrowRightIcon": 3004,
	"./ArrowRightIcon.tsx": 3004,
	"./ArrowRightStickIcon": 90732,
	"./ArrowRightStickIcon.tsx": 90732,
	"./ArrowUpFilledIcon": 3561,
	"./ArrowUpFilledIcon.tsx": 3561,
	"./ArrowUpIcon": 18889,
	"./ArrowUpIcon.tsx": 18889,
	"./AttentionIcon": 60271,
	"./AttentionIcon.tsx": 60271,
	"./BioIcon": 18279,
	"./BioIcon.tsx": 18279,
	"./BluetoothIcon": 64107,
	"./BluetoothIcon.tsx": 64107,
	"./BuildingIcon": 26035,
	"./BuildingIcon.tsx": 26035,
	"./CalendarIcon": 51957,
	"./CalendarIcon.tsx": 51957,
	"./ChatIcon": 32969,
	"./ChatIcon.tsx": 32969,
	"./CheckIcon": 87437,
	"./CheckIcon.tsx": 87437,
	"./CloseIcon": 16161,
	"./CloseIcon.tsx": 16161,
	"./ConfirmationIcon": 53636,
	"./ConfirmationIcon.tsx": 53636,
	"./CopyIcon": 18244,
	"./CopyIcon.tsx": 18244,
	"./CupIcon": 27765,
	"./CupIcon.tsx": 27765,
	"./CustomizabilityIcon": 8799,
	"./CustomizabilityIcon.tsx": 8799,
	"./DHLExpressIcon": 43599,
	"./DHLExpressIcon.tsx": 43599,
	"./DHLIcon": 48413,
	"./DHLIcon.tsx": 48413,
	"./DebitCardIcon": 36797,
	"./DebitCardIcon.tsx": 36797,
	"./DebitIcon": 84459,
	"./DebitIcon.tsx": 84459,
	"./DecalcificationIcon": 6383,
	"./DecalcificationIcon.tsx": 6383,
	"./DeleteIcon": 45834,
	"./DeleteIcon.tsx": 45834,
	"./DownloadIcon": 7551,
	"./DownloadIcon.tsx": 7551,
	"./EditIcon": 26343,
	"./EditIcon.tsx": 26343,
	"./EditOrderIcon": 673,
	"./EditOrderIcon.tsx": 673,
	"./EyeOff": 98938,
	"./EyeOff.tsx": 98938,
	"./EyeOn": 58078,
	"./EyeOn.tsx": 58078,
	"./FacebookIcon": 45735,
	"./FacebookIcon.tsx": 45735,
	"./FacebookMessengerIcon": 63648,
	"./FacebookMessengerIcon.tsx": 63648,
	"./FairTradeIcon": 78253,
	"./FairTradeIcon.tsx": 78253,
	"./FileIcon": 48209,
	"./FileIcon.tsx": 48209,
	"./GoogleAppStoreIcon": 926,
	"./GoogleAppStoreIcon.tsx": 926,
	"./HomeIcon": 81030,
	"./HomeIcon.tsx": 81030,
	"./HouseIcon": 42841,
	"./HouseIcon.tsx": 42841,
	"./InformationIcon": 76851,
	"./InformationIcon.tsx": 76851,
	"./InformationNoPaddingIcon": 47729,
	"./InformationNoPaddingIcon.tsx": 47729,
	"./InstagramIcon": 34857,
	"./InstagramIcon.tsx": 34857,
	"./InvoiceIcon": 68888,
	"./InvoiceIcon.tsx": 68888,
	"./InvoiceWhiteIcon": 28635,
	"./InvoiceWhiteIcon.tsx": 28635,
	"./LinkIcon": 35087,
	"./LinkIcon.tsx": 35087,
	"./LogoutIcon": 73225,
	"./LogoutIcon.tsx": 73225,
	"./MasterCardIcon": 87283,
	"./MasterCardIcon.tsx": 87283,
	"./MenuIcon": 61546,
	"./MenuIcon.tsx": 61546,
	"./MoreServicesIcon": 9288,
	"./MoreServicesIcon.tsx": 9288,
	"./MoreServicesTextIcon": 21069,
	"./MoreServicesTextIcon.tsx": 21069,
	"./NoWaterIcon": 76867,
	"./NoWaterIcon.tsx": 76867,
	"./OrderConfirmationIcon": 24314,
	"./OrderConfirmationIcon.tsx": 24314,
	"./OrderInvoiceIcon": 52734,
	"./OrderInvoiceIcon.tsx": 52734,
	"./PauseIcon": 50875,
	"./PauseIcon.tsx": 50875,
	"./PayPalIcon": 48014,
	"./PayPalIcon.tsx": 48014,
	"./PinterestIcon": 18215,
	"./PinterestIcon.tsx": 18215,
	"./PlayIcon": 94129,
	"./PlayIcon.tsx": 94129,
	"./PlusIcon": 64707,
	"./PlusIcon.tsx": 64707,
	"./PowerButtonIcon": 3374,
	"./PowerButtonIcon.tsx": 3374,
	"./ReceiptIcon": 91697,
	"./ReceiptIcon.tsx": 91697,
	"./Refresh": 95567,
	"./Refresh.tsx": 95567,
	"./RepairIcon": 19556,
	"./RepairIcon.tsx": 19556,
	"./RepairTextIcon": 78737,
	"./RepairTextIcon.tsx": 78737,
	"./ReturnLabelIcon": 48541,
	"./ReturnLabelIcon.tsx": 48541,
	"./SearchIcon": 76415,
	"./SearchIcon.tsx": 76415,
	"./SecurityIcon": 5417,
	"./SecurityIcon.tsx": 5417,
	"./Send180Icon": 62658,
	"./Send180Icon.tsx": 62658,
	"./Send4Icon": 88391,
	"./Send4Icon.tsx": 88391,
	"./SendIcon": 71445,
	"./SendIcon.tsx": 71445,
	"./SendWithDotIcon": 1778,
	"./SendWithDotIcon.tsx": 1778,
	"./SoundEqualizerIcon": 34084,
	"./SoundEqualizerIcon.tsx": 34084,
	"./SoundMuteIcon": 83019,
	"./SoundMuteIcon.tsx": 83019,
	"./SquareFilledIcon": 84778,
	"./SquareFilledIcon.tsx": 84778,
	"./SquareIcon": 97934,
	"./SquareIcon.tsx": 97934,
	"./SteeringIcon": 69994,
	"./SteeringIcon.tsx": 69994,
	"./SteeringTextIcon": 83303,
	"./SteeringTextIcon.tsx": 83303,
	"./TelephoneIcon": 87357,
	"./TelephoneIcon.tsx": 87357,
	"./TwitterIcon": 5156,
	"./TwitterIcon.tsx": 5156,
	"./UpdateIcon": 1044,
	"./UpdateIcon.tsx": 1044,
	"./VideoExpandIcon": 40316,
	"./VideoExpandIcon.tsx": 40316,
	"./VisaCardIcon": 1550,
	"./VisaCardIcon.tsx": 1550,
	"./VolumeControlIcon": 64696,
	"./VolumeControlIcon.tsx": 64696,
	"./WebIcon": 44839,
	"./WebIcon.tsx": 44839,
	"./WhatsAppIcon": 1965,
	"./WhatsAppIcon.tsx": 1965,
	"./Youtube": 61957,
	"./Youtube.tsx": 61957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1038;
module.exports = webpackContext;